exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fab-container[data-v-9f1dbca0] {\n  position: fixed;\n  background-color: white;\n  bottom: 16px;\n  right: 16px;\n  display: flex;\n  gap: 8px;\n  z-index: 1000;\n  padding-right: 40px;\n}\n.menu[data-v-9f1dbca0] {\n  display: flex;\n  justify-content: flex-end;\n  position: relative;\n  top: -8px;\n  right: 16px;\n}\n.main-table-view[data-v-9f1dbca0] {\n  height: 85vh;\n  overflow: auto;\n}\n", ""]);

// exports
